import axios from 'axios';
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
let navigate;

export const setNavigate = (navFunc) => {
    navigate = navFunc;
};

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'https://sql-resume.vercel.app/',
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const auth = JSON.parse(localStorage.getItem('auth'));
        if (auth && auth.accessToken) {
            config.headers.Authorization = `Bearer ${auth.accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            const storedAuth = localStorage.getItem('auth');
            const authData = JSON.parse(storedAuth);
            const refreshToken = authData?.refreshToken;

            if (refreshToken) {
                try {
                    const { data } = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL || 'https://sql-resume.vercel.app/'}/api/auth/refresh-token`,
                        { refreshToken }
                    );

                    authData.accessToken = data.accessToken;
                    localStorage.setItem('auth', JSON.stringify(authData));
                    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;
                    originalRequest.headers['Authorization'] = `Bearer ${data.accessToken}`;

                    return axiosInstance(originalRequest);
                } catch (err) {
                    //console.error('Failed to refresh token', err);
                    localStorage.removeItem('auth');
                    if (navigate) {
                        navigate('/login');
                    } else {
                        window.location.href = '/login';
                    }
                    return Promise.reject(err);
                }
            } else {
                localStorage.removeItem('auth');
                if (navigate) {
                    navigate('/login');
                } else {
                    window.location.href = '/login';
                }
                return Promise.reject(error);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
